// extracted by mini-css-extract-plugin
export default {"inputWrapper":"SearchInput_inputWrapper__-AG39","searchIcon":"SearchInput_searchIcon__ma4lb","root":"SearchInput_root__2kqtZ"};